export const resizeGuideId = "resize-guide";
